import PropTypes from 'prop-types'

import PanelBestOffers from '@adv-mt/mt-panel-best-offers'

import LinkFactory from '../../../../../components/LinkFactory/index.js'
import {NEWS_DETAIL_BASE_CLASS} from '../../config.js'

export const SidebarBestOffers = ({bestOffers, showLogo, title}) => {
  return (
    <div className={`${NEWS_DETAIL_BASE_CLASS}-relatedContent`}>
      <PanelBestOffers bestOffers={bestOffers} linkFactory={LinkFactory} showLogo={showLogo} title={title} />
    </div>
  )
}

SidebarBestOffers.propTypes = {
  bestOffers: PropTypes.array.isRequired,
  showLogo: PropTypes.bool,
  title: PropTypes.string
}
